export const backendKeyMap: Record<string, string> = {
  is_live: "Is live",
  created_before: "Created before",
  created_after: "Created after",
  amount_less_than: "Amount less than",
  amount_more_than: "Amount more than",
  provider_live_status: "Provider live status",
  start_date: "Start date",
  end_date: "End date",
  renewal_date_from: "Renewal date from",
  renewal_date_to: "Renewal date to",
  intent_id: "Intent ID",
  webhook_url: "Webhook URL",
  tokenize_card: "Tokenized card",
  custom_fields: "Custom fields",
  statement_descriptor: "Statement descriptor",
  expires_after_seconds: "Expires after seconds",
  custom_forms: "Custom forms",
  payment_method_details: "Payment method details",
  payout_method_details: "Payout method details",
  shipping_details: "Shipping details",
  billing_details: "Billing details",
  top_up_wallet: "Top up wallet",
  use_wallet: "Use wallet",
  hide_retry_button: "Hide retry button",
  hide_try_different_method_button: "Hide retry different method button",
  skip_3ds: "Skip 3ds",
  requires_shipping_data: "Required shipping date",
  hide_amount_sidebar: "Hide amount sidebar",
  hide_header: "Hide header",
  form_only: "Form only",
  hide_loader_message: "Hide loader message",
  hide_form_header_message: "Hide form header message",
  intent_details: "Intent details",
  request_id: "Request Id",
  additional_details: "Additional details",
  phone_number: "Phone number",
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  name: "Name",
  label: "Label",
  type: "Type",
  number: "Number",
  expires: "Expires",
  required: "Required",
  choices: "Choices",
  PURCHASE: "Purchase",
  AUTHORIZE: "Authorize",
  CAPTURE: "Capture",
  REFUND: "Refund",
  FULL_REFUND: "Full refund",
  PARTIAL_REFUND: "Partial refund",
  VOID: "Void",
  DECREASE_AMOUNT: "Decrease amount",
  transaction_details: "Transaction details",
  transaction_id: "Transaction ID",
  live_status: "Live status",
  provider_transaction_fields: "Provider transaction fields",
  payment_method: "Payment method",
  shipping_data: "Shipping data",
  billing_data: "Billing data",
  method_details: "Method details",
  card_token: "Card token",
  risk_level: "Risk level",
  action: "Action",
  flow: "Flow",
  connection: "Connection",
  amount_breakdown: "Amount Breakdown",
  trigger: "Trigger",
  description: "Description",
  underlying_payin_method: "Underlying payin method",
  token_type: "Token type",
};
